import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { popUpMessageChange, 
        editCards, 
        deleteCards, 
        editFeaturesGroup, 
        editFigures,
        toggleSwitch,
        selectedCardsGroupsChange } from '../../actions';

import { _ } from '../../functions/translator.js';

import { Button } from '@material-ui/core';

import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { Form } from 'react-bootstrap';

import SendIcon from '@material-ui/icons/Send';

import { postData } from '../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups';
import { showMessage } from '../../functions/popUpMessage.js';
import { ToggleActions } from '../../constants/constants.js';

const RegisterSelect = (props) => {
    const [protocolIds, setProtocolIds] = useState([]);
    const [inputProtocolValue, setInputProtocolValue] = useState('');
    const [showProtocol, setShowProtocol] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [customCardFieldSelects, setCustomCardFieldSelects] = useState({});

    useEffect(() => {
        if (props.addNewRegister.value?.protocol_id) {
            setShowProtocol(true)
        }
    }, [props.addNewRegister]);

    const handleOnClick = async () => {
        const message = _("Generando Nuevos Registros") + '...';
        showMessage(props, message, { loading: true });
        const urlPost = {
            project_id: props.projectData.id,
            protocol_ids: protocolIds,
            cards_group_ids: props.selectedCardsGroups,
            customcard_id: props.addNewRegister.value.id,
            grouped: isChecked,
            customcardfields:customCardFieldSelects,
        };

        handleClose();
        const response = await postData('/web-api/create-related-cards-groups', urlPost);
        handleResponse(response);
    };

    const handleClose = () => {
        props.toggleSwitch(ToggleActions.ADD_NEW_REGISTER, false);
        setProtocolIds([]);
        setInputProtocolValue('');
        setShowProtocol(false)
        setIsChecked(false)
        props.selectedCardsGroupsChange([]);
    };

    const handleResponse = async (response) => {
        if (response && response.status === 'success') {
            reloadCardsGroupsFeatures(props, response.new_cards_group_ids);
            showMessage(props, '¡' + _('Se han generado los protocolos correctamente') + '!');
        } else {
            showMessage(props, _('No se pudieron generar los protocolos') + '.');
        }
    };

    const handleCheckChange = () => {
        setIsChecked(!isChecked);
      };

    const handleProtocolChange = (event, value) => {
        const newProtocolIds = value.map(protocolInfo => protocolInfo.id);
        setProtocolIds(newProtocolIds);
    };

    const handleProtocolInputChange = (event, value, reason) => {
        if (reason === 'input') {
            setInputProtocolValue(value);
        }
    };

    const handleSelectOptionsChange = (event, value, type) => {
        setCustomCardFieldSelects({...customCardFieldSelects,[type]:value.attributes.name})
    };

    const filterOptions = (options, state) => {
        const filteredOptions = [];
        const searchInput = state.inputValue.trim().toLowerCase();
        const hasInputText = searchInput.length > 0;
        for (const option of options) {
            if (protocolIds.includes(option.id)) continue;
            const protocolName = option.name.toLowerCase();
            if (hasInputText && !protocolName.includes(searchInput)) continue;
            filteredOptions.push(option);
        }
        return filteredOptions;
    };

    const customCardsOptions = [];
    for (const customcardData of Object.values(props.projectData.customcards)) {
        if (customcardData.attributes.gps) {
            customCardsOptions.push({
                id: customcardData.id,
                name: customcardData.attributes.name,
                protocol_id: customcardData.attributes.protocol_id
            });
        }
        
    }

    const render = props.addNewRegister.show;
    if (!render) return <div></div>;
    const customCardFieldsData = Object.values(props.projectData.customcards[props.addNewRegister.value.id].customcardfields).filter(c => c.attributes.type_ === "select")

    let stageProtocolIds = [];
    for (const stageData of Object.values(props.projectData.stages)) {
        if (props.stageIds.length > 0 && !props.stageIds.includes(stageData.id)) continue;
        stageProtocolIds = stageProtocolIds.concat(
            Object.keys(stageData.protocols).map(protocolId => parseInt(protocolId))
        );
    }

    const protocolOptions = [];
    for (const protocolgroupData of Object.values(props.projectData.protocolgroups)) {
        const protocolgroupName = protocolgroupData.attributes.name;
        for (const protocolData of Object.values(protocolgroupData.protocols)) {
            if (!stageProtocolIds.includes(protocolData.id)) continue;
            const protocolName = protocolData.attributes.name;
            const protocolFullName = `${protocolgroupName} - ${protocolName}`;
            protocolOptions.push({
                id: protocolData.id,
                name: protocolFullName
            });
        }
    }

    return (
        <div>
            <div className='sensitive-background' onClick={handleClose}></div>
            <div className="add-cards-groups-card-layout card-color">
                <h3 className='mt-4 mb-4'>{_("Crear Nuevo Registro")}</h3>
                {customCardFieldsData.map((customcardField) => {
                    let selectOptions = customcardField.selectoptions
                    return <>
                            <Form.Label>{customcardField.attributes.name}:</Form.Label>
                            <Autocomplete
                            options={Object.values(selectOptions)}
                            getOptionLabel={(option) => option.attributes.name}
                            onChange={(event, value) => handleSelectOptionsChange(event, value, customcardField.attributes.reference_field)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant='outlined'
                                    placeholder={_('Busca Aquí') + '...'}
                                />
                            )}
                            className='mb-2'
                            />
                            </>
                    }
                )}
                {showProtocol &&
                <div>
                    <h4 className='mt-4 mb-4'>{_("Seleccione los Protocolos que desea agregar")}</h4>
                    <Form.Label>{_('Protocolos')}:</Form.Label>
                    <Autocomplete
                        multiple
                        options={protocolOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.name}
                        onChange={handleProtocolChange}
                        inputValue={inputProtocolValue}
                        onInputChange={handleProtocolInputChange}
                        filterOptions={filterOptions}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant='outlined'
                            />
                        )}
                    />
                </div>}
                <Form.Group className='mt-2' controlId="check">
                    <Form.Check
                    className='w-75'
                    type="checkbox" 
                    label={_('Agrupar')}
                    checked={isChecked}
                    onChange={handleCheckChange}
                    name="check"
                    />
                </Form.Group>
                <div className='d-flex justify-content-center'>
                    <Button variant="contained" onClick={handleOnClick} className='success-button mt-4'>
                        <SendIcon />
                        <span style={{ paddingLeft: 10 }}>{_('Generar')}</span>
                    </Button>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        projectData         : state.projectData,
        popup               : state.popup,
        popUpMenu           : state.popUpMenu,
        day                 : state.day,
        cardCategoryIds     : state.filters.cardCategoryIds,
        protocolsIds        : state.filters.protocolIds,
        status              : state.filters.status,
        customcardId        : state.filters.customcardId,
        userRole            : state.userRole,
        selectedCardsGroups : state.selectedCardsGroups,
        qualityProgress     : state.qualityProgress,
        zoneIds             : state.filters.zoneIds,
        editMode            : state.switches.editMode,
        activeTab           : state.activeTab,
        stageIds            : state.filters.stageIds,
        addNewRegister      : state.switches.addNewRegister,
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleSwitch,
        selectedCardsGroupsChange,
        popUpMessageChange,
        deleteCards,
        editCards,
        editFeaturesGroup,
        editFigures
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(RegisterSelect);
